"use client";

import { useState, useCallback } from "react";

const STORAGE_KEY = "kurb_search_tips_seen";

function markSeen(): void {
  localStorage.setItem(STORAGE_KEY, "1");
}

export function useSearchTips() {
  const [isOpen, setIsOpen] = useState(false);

  const openIfUnseen = useCallback(() => {
    if (typeof window === "undefined") return;
    // THIS IS JUST ANNOYING
    // if (!hasSeen()) setIsOpen(true);
  }, []);

  const open = useCallback(() => {
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    markSeen();
    setIsOpen(false);
  }, []);

  return { isOpen, openIfUnseen, open, close };
}
